import 'angular:locale/data:es-ES';
import 'angular:locale/data:de-AT';
import 'angular:locale/data:en-GB';
import 'angular:locale/data:it';
import 'angular:locale/data:cs-CZ';
import 'angular:locale/data:cs';
import 'angular:locale/data:sk';
import 'angular:locale/data:it-CH';
import 'angular:locale/data:fr-CH';
import 'angular:locale/data:de-CH';
import 'angular:locale/data:fr-BE';
import 'angular:locale/data:nl-BE';
import 'angular:locale/data:en-CH';
import 'angular:locale/data:en-AT';
import 'angular:locale/data:en-DE';
import 'angular:locale/data:en-CZ';
import 'angular:locale/data:en-SE';
import 'angular:locale/data:de';
import 'angular:locale/data:nl';
import 'angular:locale/data:sv';
import 'angular:locale/data:en-US';
import './apps/portal-fe/src/polyfills.ts';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
